import { classNames } from 'primereact/utils'
import styles from '../../styles/CustomButton.module.css'

export default function CustomButton({ label, icon, iconPos = "left", loading, severity, rounded, outlined, text, onClick, disabled, size, type = "button", className, style }) {

  // Define font size based on size prop
  const fontSize = { small: '12px', large: '18px' }[size] || '16px';

  // Define icon styles based on position
  const iconLeftStyle = { fontSize: fontSize, marginRight: "5px" };
  const iconRightStyle = { fontSize: fontSize, marginLeft: "5px" };
  const iconLoading = 'pi pi-spin pi-spinner';

  // Determine button class based on severity
  const severityMap = {
    primary: styles.btnPrimary,
    secondary: styles.btnSecondary,
    success: styles.btnSuccess,
    info: styles.btnInfo,
    warning: styles.btnWarning,
    danger: styles.btnDanger,
  };
  const severityClass = severityMap[severity] || styles.btnPrimary;

  return (
    <button
      className={classNames(className, styles.btn, severityClass, rounded ? styles.btnRounded : "", outlined ? styles.btnOutlined : "", text ? styles.btnText : "")}
      onClick={onClick}
      disabled={disabled || loading}
      style={{ ...style, fontSize: fontSize }}
      type={type}
    >
      {(icon || loading) && iconPos === 'left' && <i className={`${loading ? iconLoading : icon}`} style={iconLeftStyle} />}
      {label}
      {(icon || loading) && iconPos === 'right' && <i className={`${loading ? iconLoading : icon}`} style={iconRightStyle} />}
    </button>
  )
}
